// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2N4yA","content":"LayoutSettings_content__2GVDx"};